import { CustomFile } from "../../../../../Helpers/file";

export const extractFileExtension = (fileName: string): string =>
    fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length).toLowerCase() || fileName;

export interface FileProps {
    id?: string;
    uploadFile: CustomFile;
    errorMessage?: JSX.Element;
    warningMessage?: JSX.Element;
    driveUri?: string;
    excelUri?: string;
    status?: UploadFileStatuses;
    instancesInfo?: InstancesInFile;
    ndsTotalSum?: string;
}

export interface InstancesInFile {
    count?: number;
    description?: string;
}

export interface FilePropsWithTypeId extends FileProps {
    typeId?: string;
}

export enum UploadFileStatuses {
    new = "new",
    progress = "progress",
    error = "error",
    success = "success",
}

export enum PatchFufSteps {
    SelectCombineFufMethod,
    SelectCombineSumMethod,
    SelectFiles,
    ErrorMessage,
    LoadToForm,
    ShowCombineResult,
    ConfirmMerge,
}

export enum TableType {
    static = "static",
    dynamic = "dynamic",
}

export enum TypeFileUploadErrors {
    invalidXml = "InvalidXml",
    fufSizeTooLarge = "FufSizeTooLarge",
}
